var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMonitorProbabilisticFlakiness = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1140_29157)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.66666 11.3333C10 11.3333 10.5333 10.6667 10.5333 9.46666V6.66666C10.5333 5.33332 11.2 4.46666 12.6667 4.66666",
  stroke: "currentColor",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.66666 7.46667H12.4667",
  stroke: "currentColor",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.666664 6.66667L0.666664 11.3333",
  stroke: "currentColor",
  strokeWidth: 1.25,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.666664 4.66667H2.33333C3.25381 4.66667 4 5.41286 4 6.33334V6.33334C4 7.25381 3.25381 8 2.33333 8H0.666664V4.66667Z",
  stroke: "currentColor",
  strokeWidth: 1.25,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.16332 2C6.39254 3.90635 5.99751 5.94372 5.99999 8C5.99999 10.122 6.41332 12.1467 7.16332 14M14.3333 2C14.978 3.85333 15.3333 5.878 15.3333 8C15.3333 10.122 14.978 12.1467 14.3333 14",
  stroke: "currentColor",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1140_29157"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})))));
export default SvgMonitorProbabilisticFlakiness;